<okeey-cash-slider [slides]="journeySlides"></okeey-cash-slider>
